<template>
  <router-view />
</template>
<script>
import { EventBus } from "@/common/eventbus.js";
import { handleValidationError } from "@/common/utils";

export default {
  created() {
    // Listen for validation errors globally
    EventBus.$on("validation-error", handleValidationError);
  },
};
</script>
<style lang="scss">
@import "@/scss/d2c/journey.scss";
</style>
